const normalizedRoles = (roles: readonly (string | undefined)[]): Set<string> =>
    new Set(roles.filter((role): role is string => Boolean(role)).map((role) => role.toLowerCase()));

export function userRolesHaveRequiredRole(
    userRoles: readonly (string | undefined)[],
    requiredRole?: string | readonly string[],
): boolean {
    if (!requiredRole || (Array.isArray(requiredRole) && requiredRole.length === 0)) {
        return true;
    }

    const available = normalizedRoles(userRoles);
    const required = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    return required.some((role) => available.has(role.toLowerCase()));
}
